import { IVisibleLogic } from 'config'

export type LoanApplicationDateRuleKey =
  | 'loanApplicationEntry'
  | 'statusSubStatus'
  | 'sixPiecesOfData'
  | 'sendApplicationToBorrower'
  | 'wetSignSelected'

export interface ILoanApplicationDateRuleConfig {
  enabled: boolean
  visibleLogic: IVisibleLogic[][]
  tieType?: 'status' | 'subStatus'
  tieStatuses?: string[]
  tieSubStatuses?: string[]
}

export type TLoanApplicationDateRulesConfig = Record<LoanApplicationDateRuleKey, ILoanApplicationDateRuleConfig>

export const loanApplicationDateRuleLabels: Record<LoanApplicationDateRuleKey, string> = {
  statusSubStatus: 'Tie to status / Sub Status',
  sixPiecesOfData:
    '6 Pieces of Data Entered (Name, SSN, Income Collected, Subject Property Address, As Is Value, Loan Amount)',
  loanApplicationEntry: 'The Day someone enters inside the Loan Application',
  sendApplicationToBorrower: 'Click the send application to borrower button on the loan application',
  wetSignSelected: 'Wet Sign is selected (when app is manually uploaded)',
}

export const loanApplicationDateRuleOrder: LoanApplicationDateRuleKey[] = [
  'statusSubStatus',
  'sixPiecesOfData',
  'loanApplicationEntry',
  'sendApplicationToBorrower',
  'wetSignSelected',
]

export const defaultLoanApplicationDateRuleConfig = (): ILoanApplicationDateRuleConfig => ({
  enabled: false,
  visibleLogic: [],
  tieType: 'status',
  tieStatuses: [],
  tieSubStatuses: [],
})

export const defaultLoanApplicationDateRules = (): TLoanApplicationDateRulesConfig => ({
  loanApplicationEntry: { ...defaultLoanApplicationDateRuleConfig(), enabled: true },
  statusSubStatus: defaultLoanApplicationDateRuleConfig(),
  sixPiecesOfData: defaultLoanApplicationDateRuleConfig(),
  sendApplicationToBorrower: defaultLoanApplicationDateRuleConfig(),
  wetSignSelected: defaultLoanApplicationDateRuleConfig(),
})

export const normalizeLoanApplicationDateRules = (rules: Record<string, any>): TLoanApplicationDateRulesConfig => {
  const defaults = defaultLoanApplicationDateRules()

  if (rules.loanApplicationDateRules) {
    const config = rules.loanApplicationDateRules as Partial<TLoanApplicationDateRulesConfig>
    loanApplicationDateRuleOrder.forEach((key) => {
      defaults[key] = {
        ...defaults[key],
        ...config[key],
        visibleLogic: config[key]?.visibleLogic || [],
      }
    })
    return defaults
  }

  const legacyRule = (rules.loanApplicationDateRule || 'loanApplicationEntry') as LoanApplicationDateRuleKey
  loanApplicationDateRuleOrder.forEach((key) => {
    defaults[key].enabled = key === legacyRule
  })
  defaults.statusSubStatus.tieType = rules.loanApplicationDateTieType || 'status'
  defaults.statusSubStatus.tieStatuses = rules.loanApplicationDateTieStatuses || []
  defaults.statusSubStatus.tieSubStatuses = rules.loanApplicationDateTieSubStatuses || []

  return defaults
}
